import { render, staticRenderFns } from "./GoogleLoginBtn.vue?vue&type=template&id=4c212c2e&"
import script from "./GoogleLoginBtn.vue?vue&type=script&lang=js&"
export * from "./GoogleLoginBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports